import React, { useEffect, useState, useRef, forwardRef, useCallback } from 'react';
//import { RestApiUtils } from '../utils/RestApiUtils'
import { LiveService } from '../services/live-service';
//import Debug from '../components/debug';
import LiveviewCardFB from '../components/liveview-card-fb';
import HintError from '../components/hint-error';
import { useParams, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Loading from "../components/layouts/loading";
import TitleGrows from "../components/title-grows";
import moment from 'moment'
import { UrlsUtils } from '../utils/UrlsUtils';

//Snackbar
//import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

//DateTimePicker
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';
import itLocale from 'date-fns/locale/it';

import { useFormik } from 'formik';
import LivetagAutocomplete from '../components/livetag-autocomplete';

export default function LiveDetail() {

    const navigate = useNavigate();
    const { id } = useParams();
    const ytUrlRef = useRef();
    const thumbnailRef = useRef();

    const [liveviewCard, setLiveviewCard] = useState({});
    //const [thumbnail, setThumbnail] = useState(null);
    const [tagsIds, setTagsIds] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState([]);

    const [state, setState] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: '',
        severity: 'success',
        ahduration: 3000,
        instructions: ''
    });

    const { open, vertical, horizontal, message, severity, ahduration, instructions } = state;
    const Alert = forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    //DateTimePicker
    const [dtValue, setDtValue] = useState('');

    //Image Thumbnail
    const [image, setImage] = useState('');
    const [imageFile, setImageFile] = useState(undefined);

    const onChangeThumbnail = e => {
        const imagedata = e.target.files[0];
        setImageFile(imagedata);
        if (imagedata) {
            setImage(URL.createObjectURL(imagedata));
        }
    };

    const modalRef = useRef();
    const { Modal } = require('bootstrap');

    //Formik
    const formik = useFormik({
        initialValues: liveviewCard,
        enableReinitialize: true,
        onSubmit: values => {
            alert(JSON.stringify(values, null, 2));
        },
    });

    const fetchData = useCallback(async (id) => {
        setIsLoading(true);
        let _liveviewCard = await LiveService.getDetail(id);
        if (_liveviewCard?.thumbnail) {
            _liveviewCard.thumbnail_url = _liveviewCard.thumbnail;
            _liveviewCard.thumbnail = undefined;
            // delete _liveviewCard.thumbnail;
        }
        else {
            _liveviewCard.thumbnail_url = _liveviewCard.fb_thumbnail
        }
        setDtValue(_liveviewCard.publication_date);
        setImage('');

        delete _liveviewCard.id;
        setLiveviewCard(_liveviewCard);
        console.log('_liveviewCard:', _liveviewCard);
        setIsLoading(false);

    }, [])

    useEffect(() => {
        fetchData(id);
        if (!UrlsUtils.recognizingUrl(formik.values?.fb_url)) {
            formik.setFieldValue('fb_url', 'https://www.facebook.com' + formik.values.fb_url)
        }
    }, [id, fetchData, formik.values.fb_url]);

    function showModalScreen() {
        const modalEleConf = modalRef.current;
        const bsModalConf = new Modal(modalEleConf, {
            backdrop: 'static',
            keyboard: false
        })
        bsModalConf.show();
    }

    function hideModalScreen() {
        const modalEleConf = modalRef.current;
        const bsModalConf = Modal.getInstance(modalEleConf)
        bsModalConf.hide();
    }

    function resetThumbnail() {
        thumbnailRef.current.value = '';
        setImage(null);
        /* if (liveviewCard.thumbnail) {
            setThumbnail(liveviewCard.thumbnail);
        } */
    }

    function updatePublicationDate(newDate) {
        setDtValue(newDate);
        var momentDate = moment(newDate).utc();
        formik.setFieldValue('publication_date', momentDate.format("YYYY-MM-DD[T]HH:mm:ss[Z]"));
    }

    function resetPublicationDate() {
        if (liveviewCard.publication_date) {
            setDtValue(liveviewCard.publication_date);
        }
    }

    function resetFBUrl() {
        formik.setFieldValue('fb_url', liveviewCard.fb_url)
        //setFbUrl(liveviewCard.fb_url);
    }

    function resetYTUrl() {
        formik.setFieldValue('yt_url', liveviewCard.yt_url)
        //formik.setFieldValue('yt_video_id', liveviewCard.yt_url.substring(ytUrlRef.current.value.indexOf('?') + 1));
    }

    function updateYtVideoId() {
        formik.setFieldValue('yt_video_id', formik.values.yt_url.substring(formik.values.yt_url.indexOf('?') + 1));
    }

    async function save() {

        let imsg = null;
        let data = formik.values;

        if (imageFile) {
            //formik.setFieldValue('thumbnail', imageFile)
            let formData = new FormData();
            Object.keys(data).forEach(fieldName => {
                if (fieldName !== 'tags_ids') {
                    formData.append(fieldName, data[fieldName])
                }
                else if (tagsIds !== []) {
                    //formData.append('tags_ids[]', JSON.stringify(data[fieldName]));
                    tagsIds.forEach(item => {
                        formData.append('tags_ids', item);
                    });
                } else {
                    formData.append('tags_ids', formik.values.tags_ids);
                }
            })
            formData.set('thumbnail', imageFile);
            data = formData;
        }

        try {
            /* for (var value of data.values()) {
                console.log('data: ',value);
            } */
            // console.log(formik.values)
            // console.log(liveviewCard)
            let resObject = await LiveService.update(id, data);
            let res = {
                live: resObject.data,
                error_code: resObject.status,
                error_msg: resObject.data
            };
            if (!res || res.error_code !== 200) {
                console.log(`Error setLiveview: `, res.error_msg);
                //imsg = JSON.stringify(res.error_msg);
                setErrors(res.error_msg);
                setState({
                    open: true,
                    vertical: 'top',
                    horizontal: 'center',
                    message: 'Errore, non è stato possibile salvare!',
                    severity: 'error',
                    ahduration: null,
                    instructions: imsg
                });
                return {
                    revalidate: 5,
                    notFound: true,
                }
            }
            setState({
                open: true,
                vertical: 'top',
                horizontal: 'center',
                message: 'Salvata correttamente!',
                severity: 'success',
                ahduration: 2000,
                instructions: null
            })
            console.log(`Result of PUT:`, res.live);
            setErrors([]);
            fetchData(id);
        } catch (e) {
            console.log(e);
            return {
                revalidate: 5,
                notFound: true,
            }
        }
    }

    async function elimina() {

        let msg = 'Errore, non è stato possibile eliminare la live!';
        if (!formik.values.is_fb_live) { msg = 'Errore, non è stato possibile eliminare il video!' }

        try {
            let resObject = await LiveService.delete(id);
            let res = {
                live: resObject.data,
                error_code: resObject.status,
                error_msg: resObject.data
            };
            if (!res || res.error_code !== 200) {
                console.log(`Error setLiveview: `, res.error_msg);
                setErrors(res.error_msg);
                hideModalScreen();
                setState({
                    open: true,
                    vertical: 'top',
                    horizontal: 'center',
                    message: msg,
                    severity: 'error',
                    ahduration: null,
                    instructions: res.error_msg.detail
                });
                return {
                    revalidate: 5,
                    notFound: true,
                }
            }
            setState({
                open: true,
                vertical: 'top',
                horizontal: 'center',
                message: 'Eliminata correttamente!',
                severity: 'success',
                ahduration: 1500,
                instructions: null
            })
            console.log(`Result of PATCH:`, res.live);
            setErrors([]);
            hideModalScreen();
            setTimeout(() => {
                navigate(-1);
            }, 1500);
        } catch (e) {
            console.log(e);
            return {
                revalidate: 5,
                notFound: true,
            }
        }
    }

    const handleClose = () => {
        setState({ ...state, open: false });
    };

    function handleUpdate(_tagsValue) {
        const val = _tagsValue.map(tag => ({ id: tag.id, name: tag.name, slug: tag.slug }));
        const val_ids = _tagsValue.map(tag => (tag.id));
        formik.setFieldValue('tags', val);
        formik.setFieldValue('tags_ids', val_ids);
        setTagsIds(val_ids);
    }

    return liveviewCard && (
        <>
            {formik.values.is_fb_live ? <TitleGrows txtTitle={'Live detail'} /> :
                <TitleGrows txtTitle={'Video detail'} />}
            {isLoading ? <Loading /> :
                <>
                    <div className="card mybox w-100">
                        <div className="card-body">
                            <span style={{ position: "absolute", right: "20px" }}>
                                id: {id}
                            </span>
                            <div className="card-title">
                                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                                    <div className="col-12 col-md-12 col-lg-7 col-xl-7">
                                        <span className="fw-bold">
                                            <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                                            &nbsp;Title: <HintError errors={errors?.title} ></HintError></span>

                                        <input type="text" id="title" className="form-control" style={{ width: "100%", border: errors?.title ? "2px solid red" : '' }}
                                            onChange={formik.handleChange}
                                            value={formik.values.title}
                                        />
                                    </div>
                                    <div className="col-12 col-md-12 col-lg-5 col-xl-5">
                                        <span className="fw-bold">
                                            Linked tag: <HintError errors={errors?.tags}></HintError>
                                        </span>
                                        <LivetagAutocomplete tags={liveviewCard?.tags} isMultiple={true} newLabel=''
                                            shrink={false} onUpdate={handleUpdate} noClearable={false}></LivetagAutocomplete>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item">
                                <span className="fw-bold">Description:</span>
                                <textarea id="description" className="form-control" style={{ width: "100%", minHeight: "108px", textAlign: "justify" }}
                                    onChange={formik.handleChange}
                                    value={formik.values.description}
                                >
                                </textarea>
                            </li>
                            <li className="list-group-item"><span className="fw-bold">FB status: </span>{liveviewCard.fb_status}</li>
                            {/* <li className="list-group-item">Planned start time: {liveviewCard.fb_planned_start_time}</li> */}
                            {/* <li className="list-group-item"><span className="fw-bold">Planned start time: </span><Moment format="D MMM YYYY">{liveviewCard.fb_planned_start_time}</Moment></li> */}
                            <li className="list-group-item">
                                <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                                    <div className="col-12 col-md-12 col-lg-7 col-xl-7">
                                        <span className="fw-bold">Publication date: <HintError errors={errors?.publication_date}></HintError></span>
                                        <br></br>

                                        <LocalizationProvider dateAdapter={AdapterDateFns} locale={itLocale}>
                                            <DateTimePicker
                                                renderInput={(props) =>
                                                    <>
                                                        <button type="button" className="btn btn-sm btn-primary active"
                                                            title="Ricarica la data salvata"
                                                            onClick={() => { resetPublicationDate(); }} style={{ margin: "8px 2px 0 0", minHeight: "53px" }}>Reset</button>
                                                        <TextField {...props}
                                                            style={{ width: 275, marginTop: "6px", border: errors?.publication_date ? "2px solid red" : '' }}
                                                        />
                                                    </>
                                                }
                                                mask='__/__/____ __:__:__'
                                                label="Pubblicato il"
                                                value={dtValue}
                                                onChange={(newValue) => {
                                                    updatePublicationDate(newValue);
                                                }}
                                                onError={console.log}
                                                mode='date'
                                                maxDate={new Date('2030-01-01T00:00:00')}
                                                minDate={new Date('2010-01-01T00:00:00')}
                                                //inputFormat="d MMM yyyy HH:MM"
                                                inputFormat="dd/MM/yyyy HH:mm:ss"
                                            />
                                        </LocalizationProvider>
                                    </div>
                                    <div className="col-12 col-md-12 col-lg-5 col-xl-5">
                                        <span className="fw-bold">Thumbnail:  <HintError errors={errors?.thumbnail}></HintError></span>
                                        <div>
                                            <button type="button" className="btn btn-sm btn-primary active" onClick={() => { resetThumbnail(); }}
                                                title="Ricarica il thumbnail salvato"
                                                style={{ margin: "0px 4px 0 0", minHeight: "53px" }}>Reset</button>
                                            {liveviewCard?.thumbnail_url ?
                                                <img src={liveviewCard.thumbnail_url} className="img-thumbnail" alt='Thumbnail url' style={{ width: "6rem", objectFit: "cover", maxHeight: "3.5rem" }}></img>
                                                : <FontAwesomeIcon icon={['fas', 'times']} size={'2x'} color={'red'} />
                                            }
                                            <span style={{ float: "right" }}>
                                                {image && <><img src={image} className="img-thumbnail" alt='New'
                                                    style={{ width: "6rem", objectFit: "cover", maxHeight: "3.5rem" }} />
                                                    <span className="badge bg-primary" style={{ position: "relative", top: "-25px", right: "20px" }}>
                                                        New
                                                        <span className="visually-hidden">New Thumbnail</span>
                                                    </span></>
                                                }
                                            </span>
                                            <input style={{ marginTop: "6px" }}
                                                className="form-control form-control-sm"
                                                type="file"
                                                ref={thumbnailRef}
                                                onChange={onChangeThumbnail}
                                            />
                                            {/* <small>{liveviewCard.thumbnail_url}</small> */}
                                        </div>
                                    </div>
                                </div>

                            </li>
                        </ul>
                        <div className="card-body" >
                            <div className="row" style={{ minHeight: "220px", display: "flex", justifyContent: "center" }}>
                                <div className="col-12 col-md-12 col-lg-7 col-xl-7">
                                    <div className="card-text" style={{ minHeight: "110px" }}>
                                        <span className="fw-bold">
                                            <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                                            &nbsp;FB url: <HintError errors={errors?.fb_url}></HintError></span>
                                        <input type="url" id="fb_url" className="form-control error" style={{ width: "100%", border: errors?.fb_url ? "2px solid red" : '' }}
                                            title="Inserisci URL FB (es. https://www.facebook.com/StartupItalia.eu/videos/xxxxxxxx)"
                                            onChange={formik.handleChange}
                                            value={formik.values.fb_url}
                                        />

                                        <div className="btn-group btn-group-sm" style={{ width: "100%", marginTop: "4px" }}>
                                            {liveviewCard.fb_url ? <button type="button" className="btn btn-primary active"
                                                title="Ricarica il link salvato"
                                                onClick={() => { resetFBUrl(); }} >Reset FB url</button> : ''}
                                            {liveviewCard.fb_url ? <a type="button" href={formik.values.fb_url} style={{ minWidth: "50%" }}
                                                className="my-tooltip btn btn-primary" title="Apri StartupItalia FB" target="_blank" rel="noopener noreferrer">
                                                <FontAwesomeIcon icon={['fab', 'facebook-f']} size={'2x'} />
                                            </a> : ''}
                                        </div>
                                    </div>

                                    <div className="card-text" style={{ minHeight: "110px" }}>
                                        <span className="fw-bold">YT url: <HintError errors={errors?.yt_url} ></HintError></span>
                                        <input type="url" id="yt_url" className="form-control" ref={ytUrlRef}
                                            style={{ width: "100%", border: errors?.yt_url ? "2px solid red" : '' }}
                                            title="Inserisci URL YT (es. https://www.youtube.com/watch?v=xxxxxxx)"
                                            onChange={formik.handleChange}
                                            value={formik.values.yt_url}
                                        />
                                        <div className="btn-group btn-group-sm" style={{ width: "100%", marginTop: "4px" }}>
                                            {liveviewCard.yt_url ? <button type="button" className="btn btn-primary active"
                                                title="Ricarica il link salvato"
                                                onClick={() => { resetYTUrl(); }} >Reset YT url</button> : ''}
                                            {liveviewCard.yt_url ? <a type="button" href={formik.values.yt_url} style={{ minWidth: "50%" }}
                                                className="my-tooltip btn btn-primary" title="Apri StartupItalia YT" target="_blank" rel="noopener noreferrer">
                                                <FontAwesomeIcon icon={['fab', 'youtube']} size={'2x'} />
                                            </a> : ''}
                                        </div>
                                    </div>

                                </div>
                                <div className="col-12 col-md-12 col-lg-5 col-xl-5" style={{ margin: "auto" }}>
                                    <LiveviewCardFB
                                        key={liveviewCard.id}
                                        isShow={true}
                                        liveview={liveviewCard} />
                                </div>
                            </div>
                        </div>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item">
                                <span className="fw-bold">
                                    <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                                    &nbsp;FB_video_id: <HintError errors={errors?.fb_video_id} ></HintError></span>
                                <div className="row">
                                    <div className="col-7">
                                        <input type="text" id="fb_video_id" className="form-control"
                                            style={{ width: "100%", border: errors?.fb_video_id ? "2px solid red" : '' }}
                                            onChange={formik.handleChange}
                                            value={formik.values.fb_video_id}
                                        />
                                    </div>
                                    <div className="col-5">
                                        saved<div>{liveviewCard.fb_video_id} </div>
                                    </div>
                                </div>
                            </li>
                            <li className="list-group-item">
                                <span className="fw-bold">YT_video_id: <HintError errors={errors?.yt_video_id} ></HintError></span>
                                <div className="row">
                                    <div className="col-7">
                                        <input type="text" id="yt_video_id" className="form-control"
                                            style={{ width: "100%", border: errors?.yt_video_id ? "2px solid red" : '' }}
                                            onChange={formik.handleChange}
                                            value={formik.values.yt_video_id ? formik.values.yt_video_id :
                                                (formik.values.yt_url ? updateYtVideoId() : '')}
                                        />
                                    </div>
                                    <div className="col-5">
                                        saved<div>{liveviewCard.yt_video_id} </div>
                                    </div>
                                </div>
                            </li>
                            <li className="list-group-item"><span className="fw-bold">YT_channel_id: </span>{liveviewCard.yt_channel_id}</li>
                        </ul>
                        <div style={{ margin: "12px" }}>
                            <div className="d-grid gap-2 d-md-block">
                                <div className="row">
                                    <div className="col-12 col-md-12 col-lg-6 col-xl-6">
                                        <button type="button" onClick={showModalScreen} className="btn btn-danger" style={{ width: "6rem", float: "left" }}>Elimina</button>
                                    </div>
                                    <div className="col-12 col-md-12 col-lg-6 col-xl-6">
                                        {/* <button type="button" onClick={() => onUpdate(updateCard(false), hideModal)} className="btn btn-primary" style={{ width: "6rem", float: "right" }}>Salva</button> */}
                                        <button type="button" onClick={() => save()} className="btn btn-primary" style={{ width: "6rem", float: "right" }}>Salva</button>
                                        <span style={{ color: "red", float: "right", margin: "16px 10px 0px 0px" }}><FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} /> Indica un campo obbligatorio</span>
                                    </div>
                                </div>
                                {/* {fbVid && isValidFB ? <button type="button" onClick={() => onUpdate(updateCard(false), hideModal)} className="btn btn-primary" style={{ width: "6rem", float: "right" }}>Salva</button>
                            : <button type="button" className="btn btn-primary disabled" style={{ width: "20rem", float: "right" }}>Verifica FB url e FB_video_id</button>} */}
                                <div className="modal fade" ref={modalRef} tabIndex="-1">
                                    <div className="modal-dialog modal-sm modal-dialog-centered modal-dialog-scrollable" style={{ minWidth: "400px" }}>
                                        <div className="modal-content shadow p-3 mb-3 bg-body rounded" style={{ display: "inline" }}>
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="staticBackdropLabel">{formik.values.is_fb_live ? 'Elimina la Live' : 'Elimina il Video'}</h5>
                                                <button type="button" className="btn-close" onClick={hideModalScreen} aria-label="Chiudi"></button>
                                            </div>
                                            <div className="modal-body">
                                                {formik.values.is_fb_live ? "Vuoi eliminare la Live ID " : "Vuoi eliminare il Video ID "}
                                                {liveviewCard.fb_video_id}
                                            </div>
                                            <div className="modal-footer" style={{ display: "block" }}>
                                                <div className="row">
                                                    <div className="col-12 col-md-12 col-lg-6 col-xl-6">
                                                        <button type="button" className="btn btn-primary"
                                                            style={{ minWidth: '6rem', marginLeft: '10px', float: "left" }}
                                                            onClick={hideModalScreen}>
                                                            Annulla
                                                        </button>
                                                    </div>
                                                    <div className="col-12 col-md-12 col-lg-6 col-xl-6">
                                                        <button type="button" className="btn btn-success"
                                                            style={{ minWidth: '6rem', marginRight: '10px', float: "right" }}
                                                            onClick={() => elimina()}>
                                                            Conferma
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                        <Link to={{ pathname: "/liveview" }}>
                            Torna alla lista delle lives/videos
                        </Link>
                    </div>
                    <div style={{ height: "40px" }}></div>
                    <Snackbar open={open} autoHideDuration={ahduration} onClose={handleClose}
                        anchorOrigin={{ vertical, horizontal }} >
                        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                            <div style={{ textAlign: "center" }}>{message}</div>
                            {instructions ?
                                <Alert severity="info" sx={{ margin: "10px 0 0 0" }}>
                                    {instructions}
                                </Alert>
                                : ''}
                        </Alert>
                    </Snackbar>
                    {/* <Debug obj={liveviewCard} name={"lvCard"}></Debug>
                    <Debug obj={formik.values} name={"formik.values"}></Debug> */}
                </>
            }
        </>
    );

}